import {Structures} from 'octopus-model';

export const authentication = {
    displayLoginLogo: true,
    enableSSO: false,
    enableLocalCache: true,
    floatLabelControl: 'always', // 'always' | 'never' | 'auto'
    firstConnexionRedirection: {
        default: '/achievement',
        trainer: '/home',
    },
    overrideDefaultRouteByRole: {
        learner: '/achievement',
        trainer: 'lessons/list/models',
    },
    activeChangePasswordStrategy: true,
    onlyLoginWithMail: false,
    displayGARHelper: true,
    enableGAR: true,
    urlGarRegister: 'https://www.citizencode.net/inscription-gar/',
    entButtonAllowedWithoutRules: false,// citizen-code provide dynamic rules for show or not ent button
    useUrlGarRegister: true,
    newsletterRulesAddNoSsoUser: true,
    activateAuthenticationByThirdParty: true,
    googleClientId: '1080262564187-sd06t50mcftmkf44gume7fvj67qucsjo.apps.googleusercontent.com',
    facebookAppId: '2648219812199516',
    appleRedirectUri: '/auth/apple/callback',
    appleClientId: 'com.sapiensforkids.app',
};
